import { useEffect, useState } from 'react';

/**
 * Subscribes to a media query. Use sparingly — layout belongs in CSS media
 * queries; this is for the few places JS genuinely has to branch (swapping the
 * nav between a megamenu and a drawer, hiding carousel arrows on touch).
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** True below the 1024px breakpoint, where the nav collapses to a drawer. */
export const useIsCompact = () => useMediaQuery('(max-width: 1119px)');

/** True when the user has asked for reduced motion. */
export const useReducedMotion = () => useMediaQuery('(prefers-reduced-motion: reduce)');
